













import Vue from "vue";
import Component from "vue-class-component";
import AreaNavigation from "./Navigation.vue";
import Footer from "./Footer.vue"

@Component({
  components: {
    'area-navigation': AreaNavigation,
    'nav-footer': Footer,
  },
})

export default class AreaLayout extends Vue {
  private transparency = "transparent";
  private notChrome = false;
  private clicks = 0;

  mounted(){
    this.notChrome = !(window as any).chrome;
  }

}
